module.exports = __webpack_public_path__ + "img/course2.663f81b6.png";